export default __webpack_public_path__ + "static/media/SearchIcon.992e62ae.svg";